import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ReservationLoaderPage } from "../../../reservation/reservation-loader/reservation-loader";
import { TakeawayServices } from '../../services';
import { HomePage } from '../../../home/home';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the TpvRoomMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-orders-menu',
  templateUrl: 'takeaway-orders-menu.html',
})
export class TakeawayOrdersMenuPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals:Globals) {
  }

  ionViewDidLoad() {

  }

  takeAway() {
    this.takeawayServices.menu_select_room = 'take_away';

  }
  openRoom(room) {
    this.takeawayServices.room_selected_uid = room.UID;
    this.takeawayServices.room_selected_name = room.name;
    this.takeawayServices.menu_select_room = 'room';

  }
  openCalendar() {
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.push(ReservationLoaderPage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }  
  }

  close(){
    this.globals.side_menu_active = 'dashboard';
    this.navCtrl.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-orders-menu/takeaway-orders-menu.ts